import { request } from "./building";

export interface RealizedSavingsBreakdown {
  channel: string;
  baseline_kwh: number;
  adjusted_baseline_kwh: number;
  operational_kwh: number;
  savings_kwh: number;
  weather_normalized: boolean;
  hdd_baseline: number | null;
  hdd_operational: number | null;
}

export interface RealizedSavingsReport {
  id: string;
  building_id: string;
  calculated_at: string;
  total_eur: number;
  total_kwh_savings: number;
  total_co2_kg: number;
  baseline_period_start: string;
  baseline_period_end: string;
  operational_period_start: string;
  operational_period_end: string;
  confidence_score: number;
  breakdown: RealizedSavingsBreakdown[];
}

/** Null means "not yet computed" (no baseline+operational period pair exists yet) —
 * distinct from a report whose total_eur/total_kwh_savings happen to be zero. */
export const getLatestRealizedSavings = (
  building_id: string,
): Promise<RealizedSavingsReport | null> =>
  request<RealizedSavingsReport>(
    `/buildings/${building_id}/realized-savings`,
  ).catch(() => null);
